import styled from 'styled-components';
import { THEME } from '../../../themes';
import { Body1Font, HeadlineFont, Title2Font } from '../../../themes/fonts';
import { ASSETS } from '../../../assets';
import Dialog from '../base-dialog/base-dialog.component';
import BaseButton from '../../Common/Buttons/perfect-base-button/perfect-base-button.component';

export const HeaderContainer = styled(Dialog.Header)`
  margin-top: ${THEME.SPACING.LARGE};
  display: flex;
  justify-content: center;
  height: fit-content;
`;

export const HeaderIcon = styled(ASSETS.OUTREACH_ICON)`
  width: 56px;
  height: 32px;
  fill: ${THEME.COLORS.ACCENT};
`;

export const BodyContainer = styled(Dialog.Body)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
  padding: ${THEME.SPACING.BASE} ${THEME.SPACING.GIANT} ${THEME.SPACING.XLOOSE};
  overflow: hidden;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Headline = styled.div`
  ${HeadlineFont};
  font-weight: 500;
  color: ${THEME.COLORS.CONTENT_A};
`;

export const Title = styled.div`
  ${Title2Font};
  font-weight: 600;
  color: ${THEME.COLORS.CONTENT_A};
  margin-top: ${THEME.SPACING.TINO};
`;

export const Description = styled.div`
  ${Body1Font};
  margin-top: ${THEME.SPACING.LOOSE};
  color: ${THEME.COLORS_RGB.PRIMARY_DARK_MED};
  line-height: 24px;
`;

export const ButtonsContainer = styled.div`
  margin-top: ${THEME.SPACING.MEDIUM};
  display: flex;
  flex-direction: column;
  gap: ${THEME.SPACING.TINY};
  justify-content: center;
  align-items: center;
`;

export const ActionButton = styled(BaseButton)`
  background-color: ${THEME.COLORS.ACCENT};
  width: 184px;
`;
